import { Box } from '@mui/material'
import { useCandidateSqlSearch } from 'recruiter/hooks'
import { CandidateSearchResultsTable } from 'recruiter/components/CandidateSearchResultsTable'
import { candidateTableColumns } from 'recruiter/components/candidateTableColumns'
import { useCandidateFilterTabs } from 'recruiter/components/CandidateTableToolbar/useCandidateFilterTabs'
import { buildClientSearchesFilterTabs } from './clientSearchesFilterTabs'
import { ProcessStatusGroupTabs } from './ProcessStatusGroupTabs'

export function ClientCandidateTable() {
    const {
        tableState,
        setTableState,
        data,
        isLoading,
        selectedCandidateIds,
        setSelectedCandidateIds,
    } = useCandidateSqlSearch()

    const tabs = useCandidateFilterTabs(buildClientSearchesFilterTabs)

    return (
        <Box sx={{ flex: 1, minWidth: 0, overflow: 'hidden', display: 'flex' }}>
            <CandidateSearchResultsTable
                columns={candidateTableColumns}
                data={data}
                loading={isLoading}
                sort={tableState.sort}
                selectedCandidateIds={selectedCandidateIds}
                onSortChange={(sort) => setTableState({ sort })}
                onSelectionChange={setSelectedCandidateIds}
                filterTabs={tabs}
                endContent={<ProcessStatusGroupTabs />}
            />
        </Box>
    )
}
